import { useState, useEffect } from 'react';

export default function useWindowDimensions() {

    const [windowDimensions, setWindowDimensions] = useState({
        width: undefined,
        height: undefined,
    });

    useEffect(() => {
        // only execute all the code below in client side
        if (typeof window !== 'undefined') {
            // Handler to call on window resize
            const handleResize = () => {
                // Set window width/height to state
                setWindowDimensions({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }
        
            // Add event listener
            window.addEventListener("resize", handleResize, { passive: true });
            
            // Call handler right away so state gets updated with initial window size
            handleResize();
            
            // Remove event listener on cleanup
            return () => window.removeEventListener("resize", handleResize, { passive: true });
        }
    }, []); // Empty array ensures that effect is only run on mount
    return windowDimensions;
}